import { Component, Input } from '@angular/core';


@Component({
    selector: 'delivery',
    templateUrl: './delivery.component.html',
    styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent {

    @Input() info : any;
    @Input() plain : any = false;

    constructor( 
    ){
    }
}